import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getAnalysisAutomationScoreOperator = (
  analysisAutomationItem: AutomationFormItem
): RequirementConditionOperator => {
  const condition = analysisAutomationItem.requirementConditions.find(
    (condition) =>
      condition.type === RequirementConditionType.CandidateScoreCondition
  );
  return (
    condition?.operator || RequirementConditionOperator.EqualToOrGreaterThan
  );
};
